import manifest from "./manifest.json";

/**
 * Echte Referenz-Screenshots (Auftrag 2026-10-28, Abschnitt 1.5 a).
 * Erzeugt von `scripts/capture-references.mjs` (nur lokal), abgelegt unter
 * `public/images/references/<key>-desktop.webp` / `-mobile.webp`. Welche
 * Dateien vorhanden sind, steht in `manifest.json` (vom Skript gepflegt) –
 * fehlt ein Bild, wird der Slot weggelassen, nie ein Platzhalter gezeigt.
 */
export type ReferenceSite = {
  key: string;
  /** Anzeigename des Kunden (für alt-Text und Bildunterschrift). */
  name: string;
  /** Muster, mit dem `portfolio_projects.client_name` zugeordnet wird. */
  match: string;
  url: string;
  industry: string;
  location: string;
};

export const REFERENCE_SITES: ReferenceSite[] = [
  { key: "siebenson", name: "Michael Siebenson GmbH & Co. KG", match: "siebenson", url: "https://siebenson.com", industry: "Bauunternehmen", location: "Schweinfurt" },
  { key: "hippeli", name: "Immobilien Hippeli GmbH", match: "hippeli", url: "https://www.immobilien-hippeli.de", industry: "Immobilienmakler", location: "Bad Neustadt a. d. Saale" },
  { key: "schneider", name: "Elektro Schneider GmbH", match: "schneider", url: "https://www.schneider-wipfeld.de", industry: "Elektrofachbetrieb", location: "Wipfeld bei Würzburg" },
  { key: "play2gether", name: "Play2Gether", match: "play2gether", url: "https://play2gether.gg", industry: "Gaming-Community", location: "" },
  { key: "dmd-studio", name: "DMD Studio GmbH", match: "dmd studio", url: "https://www.dmd-studio.de", industry: "Digitalagentur", location: "Salz bei Bad Neustadt a. d. Saale" },
];

export type ReferenceShotFiles = { desktop: string; mobile?: string };

type Manifest = { references: Record<string, { desktop?: string; mobile?: string }>; mockups: string[] };
const data = manifest as Manifest;

/** Pfade der Screenshots eines Kunden – `null`, wenn (noch) kein Desktop-Bild vorliegt. */
export function referenceShot(key: string): ReferenceShotFiles | null {
  const entry = data.references[key];
  if (!entry?.desktop) return null;
  return { desktop: entry.desktop, mobile: entry.mobile };
}

/** Referenz zu einem Portfolio-Kundennamen finden (z. B. „Immobilien Hippeli GmbH“ → hippeli). */
export function referenceForClient(clientName: string | null | undefined): ReferenceSite | null {
  const hay = (clientName ?? "").toLowerCase();
  if (!hay) return null;
  return REFERENCE_SITES.find((r) => hay.includes(r.match)) ?? null;
}

/** Vorhandenes Mockup-Bild (`public/images/mockups/<name>`), sonst `null`. */
export function mockupSrc(name: string): string | null {
  return data.mockups.includes(name) ? `/images/mockups/${name}` : null;
}
